
import React from "react";
import { ArrowRight } from "lucide-react";
import partnerLogosImage from "@/assets/partner-logos.svg";

interface HeroContentProps {
  isMobile: boolean;
}

const HeroContent = ({ isMobile }: HeroContentProps) => {

  return (
    <div className={`w-full ${isMobile ? 'text-center' : ''}`}>
      <div className={`inline-flex items-center justify-center px-3 py-1.5 rounded-full mb-2 sm:mb-4 opacity-0 animate-fade-in text-xs sm:text-sm ${isMobile ? 'mx-auto' : 'md:mx-auto lg:mx-0'}`} style={{
        animationDelay: "0.1s",
        backgroundColor: 'rgba(242, 76, 39, 0.1)',
        border: '1px solid rgba(242, 76, 39, 0.2)',
        color: 'rgba(242, 76, 39, 1)'
      }}>
        <span className="inline-flex items-center justify-center w-1.5 h-1.5 rounded-full text-white mr-2 animate-pulse" style={{
          backgroundColor: 'rgba(242, 76, 39, 1)'
        }}></span>
        <span>US Track Now Open</span>
      </div>
      
      <h1 style={{
        animationDelay: "0.3s"
      }} className={`section-title leading-tight opacity-0 animate-fade-in text-white mb-3 sm:mb-4 ${isMobile ? 'text-center text-4xl' : 'text-2xl sm:text-3xl lg:text-4xl xl:text-5xl'}`}>
        <span className="text-white">AI Hackathon</span>
        {isMobile ? (
          <>
            <br />
            <span style={{
              color: 'rgba(242, 76, 39, 1)'
            }}>$100k Funding</span>
          </>
        ) : (
          <>
            <span className="text-white"> with </span>
            <span style={{
              color: 'rgba(242, 76, 39, 1)'
            }}>$100k Funding</span>
          </>
        )}
      </h1>
      
      {/* Mobile: Logos first, then button */}
      {isMobile ? (
        <>
          <div className="mt-3 flex items-center justify-center opacity-0 animate-fade-in" style={{
            animationDelay: "0.5s"
          }}>
            <img src={partnerLogosImage} alt="Partner Logos" className="h-4 w-auto" />
          </div>
          
          <div className="flex flex-col gap-3 mt-4 opacity-0 animate-fade-in items-center justify-center" style={{
            animationDelay: "0.7s"
          }}>
            <a href="#participation-criteria" className="flex items-center justify-center group text-center text-sm w-full mx-4" style={{
              backgroundColor: 'rgba(242, 76, 39, 1)',
              borderRadius: '1440px',
              boxSizing: 'border-box',
              color: '#FFFFFF',
              cursor: 'pointer',
              lineHeight: '20px',
              padding: '12px 20px',
              border: '1px solid white'
            }}>
              Register Now
              <ArrowRight className="ml-2 w-3 h-3 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </>
      ) : (
        <>
          <div className="mt-3 flex flex-wrap items-center gap-2 opacity-0 animate-fade-in text-xs sm:text-sm" style={{
            animationDelay: "0.5s"
          }}>
            <span className="text-white font-medium">Judges from:</span>
            <img src={partnerLogosImage} alt="Partner Logos" className="h-4 w-auto" />
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 mt-4 opacity-0 animate-fade-in justify-end" style={{
            animationDelay: "0.7s"
          }}>
            <a href="#participation-criteria" className="flex items-center justify-center group text-center text-sm w-full sm:w-auto md:ml-auto lg:ml-auto" style={{
              backgroundColor: 'rgba(242, 76, 39, 1)',
              borderRadius: '1440px',
              boxSizing: 'border-box',
              color: '#FFFFFF',
              cursor: 'pointer',
              lineHeight: '20px',
              padding: '12px 20px',
              border: '1px solid white'
            }}>
              Register Now
              <ArrowRight className="ml-2 w-3 h-3 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </>
      )}
    </div>
  );
};

export default HeroContent;
